export default "__VITE_ASSET__KW4WKeCE__"